import global from '@remote/store/constantStore'
import { safeJSONParse } from '@shared/utils'
import { sendMessage } from '@xunlei/universal-native-api'
import { DeepPartial } from 'utility-types'
import { apiOrigin } from './config'

export async function getConfig (params = {}) {
  const query =  new URLSearchParams(params)
  return fetch(`https://conf-m-ssl.xunlei.com/external/3590509d-071b-4589-8dc9-98f667b4ce1a?${query}`).then(res => res.json())
}

interface GetIosUserInfo {
  avatar: string
  vip: {
    expire: string
    level: string
  }
}

// wiki: https://md.office.k8s.xunlei.cn/DURypvY5SRWqmsIC-w04Fg#POST-v1getuserinfo
export async function getIOSUserInfo (id) {
  const [err, res] = await sendMessage({
    platform: 'ios',
    name: 'xlAjax',
    params: {
      method: 'POST',
      host: apiOrigin,
      path: '/v1/getuserinfo',
      jsonRequest: 1,
      params: {
        account: String(id),
        account_type: 'userid',
        scene: 'nas-h5',
      },
    },
  })
  console.log('getuserinfo=====>', err, res)
  
  const info = (safeJSONParse(res?.data)) as DeepPartial<GetIosUserInfo>
  return info
}
